import Card from "@/pages/admin/dashboard/components/Card";
import { Grid, Typography, useMediaQuery } from "@mui/material";
import MembersImg from "@/assets/image/members.png";
import { Modal } from "@/components";
import { BarChart } from "@mui/x-charts";

function GroupMembersReport({ membersReport }) {
  const md = useMediaQuery("(max-width:450px)");

  return (
    <>
      <Grid display={"flex"} flexDirection={"column"} gap={"10px"}>
        <Grid display={"flex"} flexDirection={"row"} gap={"10px"}>
          <Modal width={md ? "100%" : "calc(100% - 420px)"}>
            <Grid
              display={"flex"}
              flexDirection={"column"}
              gap={"15px"}
              justifyContent={"space-between"}
              height={"100%"}
            >
              <Grid display={"flex"} flexDirection={"column"}>
                <img
                  height={"100px"}
                  width={"fit-content"}
                  src={MembersImg}
                  style={{ margin: "15px auto" }}
                />
                <Typography variant="h6" sx={{ color: "var(--emr-text)" }}>
                  لیست جهادگران
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    color: "var(--emr-primary-color-text)",
                    marginTop: "10px",
                  }}
                >
                  شما میتوانید لیست جهادگران گروه خود را مشاهده و مدیریت کنید.
                </Typography>
              </Grid>
              <Typography
                sx={{ color: "var(--emr-primary)", cursor: "pointer" }}
              >
                مشاهده
              </Typography>
            </Grid>
          </Modal>
          {membersReport && (
            <Grid
              display={"flex"}
              flexDirection={"row"}
              gap={"10px"}
              width={"420px"}
              height={"fit-content"}
              rowGap={"30px"}
              flexWrap={"wrap"}
            >
              <Card
                title={"کل جهادگران"}
                counter={membersReport.members}
                unit={"نفر"}
                sx={{ height: "120px" }}
              />
              <Card
                title={"جهادگران در حال جهاد"}
                counter={membersReport.membersInTrip}
                unit={"نفر"}
                sx={{ height: "120px" }}
              />
              <Card
                title={"جهادگران مرد"}
                counter={membersReport.menMembers}
                unit={"نفر"}
                sx={{ height: "120px" }}
              />
              <Card
                title={"جهادگران زن"}
                counter={membersReport.womenMembers}
                unit={"نفر"}
                sx={{ height: "120px" }}
              />
            </Grid>
          )}
        </Grid>
        <Modal width="100%" title={"تعداد جهادگران بر اساس رشته"}>
          <BarChart
            leftAxis={null}
            height={300}
            borderRadius={8}
            margin={{ top: 5, bottom: 60, left: 5, right: 5 }}
            series={[
              {
                data: membersReport.groupStatisticsResult.byFieldOfStudy.map(
                  (e) => e.count,
                ),
                type: "bar",
                color: "#5EEAD4",
              },
            ]}
            xAxis={[
              {
                scaleType: "band",
                categoryGapRatio: 0.7,
                data: membersReport.groupStatisticsResult.byFieldOfStudy.map(
                  (e) => e.fieldOfStudy,
                ),
                tickLabelStyle: {
                  angle: -90,
                  textAnchor: "center",
                  fontSize: 12,
                },
              },
            ]}
          />
        </Modal>
        <Grid
          display={"flex"}
          flexDirection={"row"}
          gap={"10px"}
          sx={{ marginTop: "20px" }}
        >
          <Modal title={"تعداد جهادگران بر اساس دهه تولد"}>
            <BarChart
              leftAxis={null}
              height={300}
              borderRadius={8}
              margin={{ top: 5, bottom: 60, left: 5, right: 5 }}
              series={[
                {
                  data: membersReport.groupStatisticsResult.byBirthDecade.map(
                    (e) => e.count,
                  ),
                  type: "bar",
                  color: "#67E8F9",
                },
              ]}
              xAxis={[
                {
                  scaleType: "band",
                  categoryGapRatio: 0.7,
                  data: membersReport.groupStatisticsResult.byBirthDecade.map(
                    (e) => e.decade,
                  ),
                  tickLabelStyle: {
                    angle: -90,
                    textAnchor: "center",
                    fontSize: 12,
                  },
                },
              ]}
            />
          </Modal>
          <Modal title={"تعداد جهادگران بر اساس دوره"}>
            <BarChart
              leftAxis={null}
              height={300}
              borderRadius={8}
              margin={{ top: 5, bottom: 60, left: 5, right: 5 }}
              series={[
                {
                  data: membersReport.groupStatisticsResult.byTripBucket.map(
                    (e) => e.count,
                  ),
                  type: "bar",
                  color: "#86EFAC",
                },
              ]}
              xAxis={[
                {
                  scaleType: "band",
                  categoryGapRatio: 0.7,
                  data: membersReport.groupStatisticsResult.byTripBucket.map(
                    (e) => parseInt(e.label) + 1,
                  ),
                  tickLabelStyle: {
                    textAnchor: "center",
                    fontSize: 12,
                  },
                },
              ]}
            />
          </Modal>
        </Grid>
      </Grid>
    </>
  );
}

export default GroupMembersReport;
